var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inspection-page"},[_c('div',{ref:"madeForm",staticClass:"left-form"},[_c('avue-form',{ref:"AvueForm",attrs:{"option":_vm.formOption},on:{"submit":_vm.submit},model:{value:(_vm.detailForm),callback:function ($$v) {_vm.detailForm=$$v},expression:"detailForm"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }